<template>
  <div class="market_left hk_stock">
    <div>
      <stock-chart></stock-chart>
    </div>

    <div class="divideSection"></div>

    <div>
      <el-row>
        <el-col :span="24" style="padding: 10px"> 港股成交量 </el-col>
      </el-row>
    </div>

    <div class="wrap">
      <div class="main">
        <el-table
          :data="tableData"
          v-loading="loading"
          border
          stripe
          size="mini"
          style="width: 100%"
        >
          <el-table-column fixed align="center" label="代码">
            <template slot-scope="scope">
              <router-link
                :to="{
                  name: 'Stockdetailed',
                  query: { symbol: 'hk' + (scope.row.symbol || '').replace(/^hk/i, ''),direction: 0 },
                }"
                class="stockLinkColor"
              >
                <span>{{ (scope.row.symbol || '').replace(/^hk/i, '') }}</span>
              </router-link>
            </template>
          </el-table-column>

          <el-table-column fixed align="center" prop="name" label="名称">
            <template slot-scope="scope">
              <router-link
                :to="{ name: 'Stockdetailed', query: { symbol: scope.row.symbol } }"
                class="stockLinkColor"
              >
                <span
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: inline-block;
                    max-width: 180px;
                  "
                  :title="scope.row.name"
                >
                  {{ scope.row.name }}
                </span>
              </router-link>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="zhi1" label="最新价"></el-table-column>
          <el-table-column align="center" prop="pricechange" label="涨跌额"></el-table-column>

          <el-table-column align="center" prop="changepercent" label="涨跌幅">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.changepercent || 0).toFixed(3) }}
            </template>
          </el-table-column>

          <el-table-column align="center" prop="buy" label="买入"></el-table-column>
          <el-table-column align="center" prop="sell" label="卖出"></el-table-column>
          <el-table-column align="center" prop="open" label="今开"></el-table-column>
          <el-table-column align="center" prop="high" label="最高"></el-table-column>
          <el-table-column align="center" prop="low" label="最低"></el-table-column>
        </el-table>

        <div class="pagination" v-if="total > pagesize">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :current-page="currentPage"
            :page-size="pagesize"
            @current-change="handleCurrentChange"
          />
        </div>

        <div class="bottombar"></div>
      </div>
    </div>
  </div>
</template>

<script>
import StockChart from "@/components/stockchart";

export default {
  name: "HKStockLongTrade",
  components: { StockChart },

  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      currentPage: 1,
      pagesize: 40,
      type: 0, // 0=trade, 1=trade_short
    };
  },

  methods: {
    loadStockData(page) {
      var that = this;
      that.loading = true;

      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_type_stock",
            type: that.type,
            page: page,
            num: that.pagesize,
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          console.log('r',res)
          var payload = (res && res.data && res.data.data) ? res.data.data : {};
          var list = Array.isArray(payload.list) ? payload.list : [];
          var total = Number(payload.total || 0);

          that.total = total;
          that.currentPage = page;

          that.tableData = list.map(function (e) {
            var newPrice = Number(e.NewPrice || 0);
            var lastClose = Number(e.LastClose || 0);

            var computedPriceChange = (newPrice - lastClose).toFixed(3);
            var computedChangePercent = lastClose
              ? (((newPrice - lastClose) / lastClose) * 100).toFixed(3)
              : "0.000";

            return {
              symbol: e.Symbol || "",
              name: e.name || "",
              zhi1: newPrice.toFixed(3),
              open: Number(e.Open || 0),
              high: Number(e.high || 0),
              low: Number(e.low || 0),
              buy: Number(e.BP1 || 0),
              sell: Number(e.SP1 || 0),
              volume: Number(e.Volume || 0),
              pricechange: e.PriceChange != null ? e.PriceChange : computedPriceChange,
              changepercent: e.PriceChangeRatio != null ? e.PriceChangeRatio : computedChangePercent,
            };
          });
        })
        .catch(function (e) {
          console.error(e);
          that.tableData = [];
          that.total = 0;
        })
        .finally(function () {
          that.loading = false;
        });
    },

    handleCurrentChange(page) {
      this.loadStockData(page);
    },
  },

  mounted() {
    this.loadStockData(1);
  },
};
</script>

<style scoped>
.main { margin-top: 10px; }
.stockLinkColor { color: rgb(0, 0, 238); }
.stockLinkColor :hover { color: #0100a0; }
.green { color: #008000; }
.bottombar { margin: 0 auto; text-align: center; padding-top: 10px; }
.divideSection { height: 10px; background: #f1f1f1; }
.hk_stock { border-left: 10px #f1f1f1 solid; }
.pagination { margin: 10px auto 0; text-align: center; }
.market_left { width: 1000px; float: right; min-height: 300px; }
</style>


// WEBPACK FOOTER //
// src/components/HKStockLongTrade.vue